import { get } from 'lodash'

export default {
  state: {
    files: {
      /**
       * [id path/name.txt] {
       *    path: // plath to storage (excluding name)
       *    file: // File object
       *    url: // public hosted file
       *    uploadPercent: //
       * }
       */
    }
  },
  getters: {
    getStorageFileUploadPercentage: (state) => (id) => {
      const file = get(state, `files[${id}]`, 0) || 0

      return file.uploadPercent || 0
    },
    getStorageFilesByPath: (state) => (path) => {
      return Object.values(state.files)
        .filter(file => file.path === path)
    },
  },
  actions: {
    deleteStorageImage({ commit, dispatch }, data) {
      const { id } = data

      const storageRef = this.$storage.ref(id)

      storageRef.delete()
        .then(() => {
          const successSnack =  {
            text: 'File removed'
          }
          dispatch('snackSuccess', successSnack)

          commit('REMOVE_STORAGE_FILE', { id })
        })
        .catch(e => {
          const successSnack =  {
            text: 'Unable to delete file'
          }
          dispatch('snackError', successSnack)
        })
    },
    loadStorageImages({ commit }, data) {
      const { storagePath } = data

      const storageRef = this.$storage.ref(storagePath)

      const addImageUrlToPath = (imageRef) => {
        const { fullPath } = imageRef
        imageRef.getDownloadURL().then((url) => {
          const successPayload = {
            file: null,
            path: storagePath,
            url,
            id: fullPath,
            uploadPercentage: 100
          }

          commit('SET_STORAGE_FILE', successPayload)
        }).catch((error) => {
          // Handle any errors
          console.log(error)
        })
      }

      const onSuccess = (result) => {
        result.items.forEach((imageRef) => {
          // And finally display them
          addImageUrlToPath(imageRef)
        })
      }

      const onError = error => {
        console.log(error)
      }

      storageRef.listAll()
        .then(onSuccess)
        .catch(onError)
    },
    doStorageUpload({ state, commit, dispatch }, data) {
      const { file, storagePath, initUrl } = data
      const { name } = file

      const path = `${storagePath}${name}`

      const storageRef = this.$storage
        .ref(path)
        .put(file)

      const onChange = (snapshot) => {
        const payload = {
          file,
          path: storagePath,
          uploadPercentage: (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          id: path,
          url: initUrl,
        }
        commit('SET_STORAGE_FILE', payload)
      }

      const onSuccess = () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          const successPayload = {
            file,
            path: storagePath,
            url,
            id: path,
            uploadPercentage: 100
          }

          commit('SET_STORAGE_FILE', successPayload)
        })

        const successSnack =  {
          text: 'File successfully uploaded'
        }
        dispatch('snackSuccess', successSnack)
      }

      const onError = (error) => {
        const errorSnack = {
          text: error.message
        }
        dispatch('snackError', errorSnack)
      }

      return storageRef.on('state_changed', onChange, onError, onSuccess)
    }
  },
  mutations: {
    REMOVE_STORAGE_FILE(state, data) {
      const { id } = data

      const newState = { ...state.files }
      delete newState[ id ]
      state.files = newState
    },
    SET_STORAGE_FILE(state, data) {
      const { id } = data
      const newState = { ...state.files }
      newState[ id ] = { ...newState[ id ], ...data }
      state.files = newState
    }
  }
}
